import React, { useCallback, useState, useEffect } from "react";
import UsersForm from "./UsersForm";
import { push } from "connected-react-router";
import { connect } from "react-redux";
import actions from "../../../actions/usersFormActions";

const UserFormPage = (props) => {
  const [dispatched, setDispatched] = useState(false);

  const { dispatch, match, saveLoading, findLoading, record, currentUser } =
    props;

  const isEditing = useCallback(() => {
    return !!match.params.id;
  }, [match.params.id]);

  const isProfile = useCallback(() => {
    const currentUser = JSON.parse(localStorage.getItem("user"));
    const currentUserId = currentUser.id;
    if (match.params.id === currentUserId) {
      return true;
    }
    return match.url === "/template/edit_profile";
  }, [match.params.id, match.url]);

  const doSubmit = (id, data) => {
    if (isEditing() || isProfile()) {
      dispatch(actions.doUpdate(id, data, isProfile()));
    } else {
      dispatch(actions.doCreate(data));
    }
  };

  useEffect(() => {
    if (isEditing()) {
      dispatch(actions.doFind(match.params.id));
    } else {
      if (isProfile()) {
        const currentUser = JSON.parse(localStorage.getItem("user"));
        const currentUserId = currentUser.user.id;
        dispatch(actions.doFind(currentUserId));
      } else {
        dispatch(actions.doNew());
      }
    }
    setDispatched(true);
  }, [match, dispatch, isEditing, isProfile]);

  return (
    <React.Fragment>
      <div className="page-top-line">
        <h2 className="page-title">Edit Profile</h2>
      </div>
      {dispatched && (
        <UsersForm
          saveLoading={saveLoading}
          findLoading={findLoading}
          currentUser={currentUser}
          record={isEditing() || isProfile() ? record : {}}
          isEditing={isEditing()}
          isProfile={isProfile()}
          onSubmit={doSubmit}
          onCancel={() => dispatch(push("/admin/users"))}
        />
      )}
    </React.Fragment>
  );
};

function mapStateToProps(store) {
  return {
    findLoading: store.users.form.findLoading,
    saveLoading: store.users.form.saveLoading,
    record: store.users.form.record,
    currentUser: store.auth.currentUser,
  };
}

export default connect(mapStateToProps)(UserFormPage);
